import { render, staticRenderFns } from "./StepNotificationConfig.vue?vue&type=template&id=752f92ed&scoped=true&"
import script from "./StepNotificationConfig.vue?vue&type=script&lang=js&"
export * from "./StepNotificationConfig.vue?vue&type=script&lang=js&"
import style0 from "./StepNotificationConfig.vue?vue&type=style&index=0&id=752f92ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f92ed",
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/RequestNotificationStepsConfigTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-request-notification-steps-config%2FStepNotificationConfig.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports